import { Flex, Heading, IconButton, IconXLine, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { Card } from "../../Card";
import CustomRTE from "../../CustomTextArea/CustomRTE";
import { CourseReviewContext } from "../CourseReview";

const CourseReviewReflections = () => {
  const { t } = useTranslation();
  const { draftData, setDraftData } = useContext(CourseReviewContext);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        height: "100%",
      }}
    >
      <Heading level="h3" as="h2" border="bottom">
        {t("courseReview.reflectionsInReview")}
      </Heading>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          padding: "0.75rem",
          margin: "-0.75rem",
          overflowY: "auto",
        }}
      >
        <CustomRTE
          id="reflection-summary"
          label={
            <Text as="p" weight="bold">
              {t("courseReview.reflectionsSummary")}
            </Text>
          }
          defaultValue={draftData.reflectionsSummary}
          onChange={(value) =>
            setDraftData((prev) => ({ ...prev, reflectionsSummary: value }))
          }
        />
        {draftData.selectedReflections?.length > 0 ? (
          draftData.selectedReflections.map((ref) => (
            <Card
              key={ref.id}
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                height: "auto",
              }}
            >
              <Flex wrap="wrap" gap="small">
                <Flex.Item shouldGrow textAlign="end">
                  <IconButton
                    screenReaderLabel={t("courseReview.removeReflection")}
                    onClick={() => {
                      setDraftData((prev) => ({
                        ...prev,
                        selectedReflections: prev.selectedReflections.filter(
                          (r) => r.id !== ref.id
                        ),
                      }));
                    }}
                    renderIcon={IconXLine}
                    size="small"
                    color="danger"
                  />
                </Flex.Item>
                <Flex.Item>
                  {ref.from_template ? (
                    <Flex wrap="wrap" gap="medium">
                      {ref.sections.map((section) => (
                        <Flex.Item key={section.id} width="100%">
                          <Flex wrap="wrap" gap="small">
                            <Flex.Item width="100%">
                              <Text weight="bold">
                                {section.header_question}
                              </Text>
                            </Flex.Item>
                            <Flex.Item>
                              <CustomRTE
                                id={section.id}
                                defaultValue={section.content}
                                onChange={(value) => {
                                  setDraftData((prev) => ({
                                    ...prev,
                                    selectedReflections:
                                      prev.selectedReflections.map((r) =>
                                        r.id === ref.id
                                          ? {
                                              ...r,
                                              sections: r.sections.map((s) =>
                                                s.id === section.id
                                                  ? { ...s, content: value }
                                                  : s
                                              ),
                                            }
                                          : r
                                      ),
                                  }));
                                }}
                                label={
                                  <Text weight="bold">
                                    {t("courseReview.revisedReflection")}
                                  </Text>
                                }
                              />
                            </Flex.Item>
                          </Flex>
                        </Flex.Item>
                      ))}
                    </Flex>
                  ) : (
                    <CustomRTE
                      id={ref.id}
                      defaultValue={ref.content}
                      onChange={(value) => {
                        setDraftData((prev) => ({
                          ...prev,
                          selectedReflections: prev.selectedReflections.map(
                            (r) =>
                              r.id === ref.id ? { ...r, content: value } : r
                          ),
                        }));
                      }}
                      label={
                        <Text weight="bold">
                          {t("courseReview.revisedReflection")}
                        </Text>
                      }
                    />
                  )}
                </Flex.Item>
              </Flex>
            </Card>
          ))
        ) : (
          <Text fontStyle="italic">
            {t("courseReview.selectReflectionsFromLeft")}
          </Text>
        )}
      </div>
    </div>
  );
};

export default CourseReviewReflections;
